export const getEditWorkshiftId = (state) =>
  state.form.workshift.loadData.workshift_id
